module.exports = __webpack_public_path__ + "img/bg-audio-5.bd498342.png";